export default __webpack_public_path__ + "static/media/test-download.9128fc55.svg";